import {
  CellType,
  ComponentType,
  GridComponentType,
  IMediaListModel,
  Orientation,
} from "@nf/common";
import React from "react";
import dynamic from "next/dynamic";

const GridComponent = dynamic(
  () =>
    import("components/Configuration/ListComponent/components/GridComponent")
);

export type TGenresGrid = {
  mediaList: IMediaListModel;
};

export const GenreGrid: React.FC<TGenresGrid> = ({ mediaList }) => (
  <GridComponent
    gridComponentType={GridComponentType.GenresScreen}
    columns={3}
    rows={mediaList?.Entities ? mediaList?.Entities?.length : 0}
    component={{
      ComponentTypeCode: ComponentType.List,
      CellType: CellType.Frame,
      Orientation: Orientation.Grid,
      MediaList: mediaList?.Entities,
    }}
  />
);

export default GenreGrid;
